module.exports = __webpack_public_path__ + "static/media/ss.e3933b44.svg";